import React from 'react';
import { getCurrentUser, editUserDetailsPassword } from '../epics-users';
import { Link, withRouter } from 'react-router-dom';
import { StaticRoutePaths } from '../../Common/ClientRoutes';
import Svgs from '../../Common/Svgs';
import { FormRow, Input, MainBtn, CancelBtn } from '../../Common/form/Elements-export';

class UserPassword extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loadingSpinner: false,
            currentPassword: '',
            newPassword: '',
            repeatNewPassword: '',

            validation: {
                currentPassword: '',
                newPassword: '',
                repeatNewPassword: ''
            }
        };
    }

    componentDidMount() {
        getCurrentUser()
            .then(resposne => {
                this.setState({
                    ...this.state,
                    userId: resposne.id,
                    username: resposne.names,
                    email: resposne.email,
                    phone: resposne.phone
                });
            })
            .catch(() => {
                this.setState({
                    ...this.state,
                    userId: '',
                    username: '',
                    email: '',
                    phone: ''
                });
            });
    }

    update = type => e => {
        this.setState({ ...this.state, [type]: e.target.value });
    };

    saveUserPasswordHandler = details => {
        this.setState({
            ...this.state,
            loadingSpinner: true
        });

        editUserDetailsPassword(details)
            .then(() => {
                this.setState({
                    ...this.state,
                    loadingSpinner: false
                });
                this.props.history.push(StaticRoutePaths.INFO_USER);
            })
            .catch(error => {
                this.setState({
                    ...this.state,
                    loadingSpinner: false,
                    validation: {
                        ...this.state.validation,
                        currentPassword:
                            this.generateErrorMessage(error.body, 'currentPassword')
                                .join(' ')
                                .trim() || '',
                        newPassword:
                            this.generateErrorMessage(error.body, 'password')
                                .join(' ')
                                .trim() || '',
                        repeatNewPassword:
                            this.generateErrorMessage(error.body, 'confirmPassword')
                                .join(' ')
                                .trim() || ''
                    }
                });
            });
    };

    cancelUserHandler = () => {
        this.props.history.push(StaticRoutePaths.INFO_USER);
    };

    generateErrorMessage = (errArray, errName) => {
        if (errArray !== null) {
            return (errArray || []).map(singleErr => {
                return singleErr.property_path === errName ? singleErr.message : '';
            });
        }
    };

    generateErrorsMessages = message => (message === '' ? null : <div className="qf-error-message">{message}</div>);

    render() {
        return (
            <div className="container">
                <div className="row qf-mb-100">
                    <div className="col-1 light-blue-bg text-center pt-3">
                        <span className="qf-page-icon">{Svgs.users}</span>
                    </div>
                    <div className="col-11 white-bg px-5">
                        <div className="row">
                            <div className="col-9">
                                <h2 className="qf-page-title">
                                    <i className="fa fa-pencil-square mr-2" />User Password
                                </h2>
                            </div>
                            <div className="col-3 align-self-center text-right">
                                <Link to={StaticRoutePaths.INFO_USER} className="qf-back-btn">
                                    <i className="fa fa-chevron-left" />Back
                                </Link>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <hr className="qf-divider-line" />
                            </div>
                        </div>
                        <FormRow>
                            <Input
                                label="* Current Password"
                                type="password"
                                handler={this.update('currentPassword')}
                                placeholder="Enter your current password"
                                value={this.state.currentPassword ? this.state.currentPassword : ''}
                                extraClasses="col-12"
                            />
                            <div className="col-12">{this.generateErrorsMessages(this.state.validation.currentPassword)}</div>
                        </FormRow>
                        <FormRow>
                            <Input
                                label="* New password"
                                type="password"
                                handler={this.update('newPassword')}
                                placeholder="Enter your new password"
                                value={this.state.newPassword ? this.state.newPassword : ''}
                                extraClasses="col-12"
                            />
                            <div className="col-12"> {this.generateErrorsMessages(this.state.validation.newPassword)}</div>
                        </FormRow>
                        <FormRow>
                            <Input
                                label="* Repeat new password"
                                type="password"
                                handler={this.update('repeatNewPassword')}
                                placeholder="Repeat your new password"
                                value={this.state.repeatNewPassword ? this.state.repeatNewPassword : ''}
                                extraClasses="col-12"
                            />
                            <div className="col-12"> {this.generateErrorsMessages(this.state.validation.repeatNewPassword)}</div>
                        </FormRow>
                        <FormRow>
                            <div className="col-2 offset-8 qf-mb-30">
                                {this.state.loadingSpinner ? (
                                    <div className="px-5 text-center p-3" />
                                ) : (
                                    <CancelBtn onclick={this.cancelUserHandler} title="Cancel" extraClasses="qf-gray-btn w-100 mt-4" />
                                )}
                            </div>

                            <div className="col-2 qf-mb-30">
                                {this.state.loadingSpinner ? (
                                    <div className="col-11 white-bg px-5 text-center p-3">
                                        <i className="fa fa-spinner fa-spin fa-2x" style={{ color: '#858585' }} />
                                    </div>
                                ) : (
                                    <MainBtn
                                        onclick={() => this.saveUserPasswordHandler(this.state)}
                                        title="Save"
                                        extraClasses="qf-blue-btn w-100 mt-4"
                                    />
                                )}
                            </div>
                        </FormRow>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(UserPassword);



// WEBPACK FOOTER //
// ./src/customModules/Users/components/User-password-form.js